import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminProfile from './AdminProfile';
import TeacherProfile from './TeacherProfile';
import StudentProfile from './StudentProfile';
import { apiService } from '../../utils/api';
import './ProfileStyles.css';

function ProfilePage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setLoading(true);
        const storedUser = JSON.parse(localStorage.getItem('user'));
        
        if (!storedUser) {
          navigate('/login');
          return;
        }
        
        const response = await apiService.getUserProfile();
        
        if (response.data.success) {
          setUser(response.data.user);
        } else {
          setError(response.data.message || 'Failed to load profile');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Error loading profile');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [navigate]);

  const renderProfileComponent = () => {
    if (!user) return null;

    switch (user.role) {
      case 'admin':
        return <AdminProfile user={user} />;
      case 'teacher':
        return navigate('/dashboard/teacher/profile');
      case 'student':
        return <StudentProfile user={user} />;
      default:
        return <div>Unknown user role</div>;
    }
  };

  if (loading) {
    return <div className="profile-container loading">Loading profile...</div>;
  }

  if (error) {
    return <div className="profile-container error">Error: {error}</div>;
  }

  return (
    <div className="profile-container">
      <h1>User Profile</h1>
      {renderProfileComponent()}
    </div>
  );
}

export default ProfilePage;